import { IconesNasAbas } from './IconesNasAbas';
import { LinksExternos } from './LinksExternos';
import { Subsistemas } from './Subsistemas';

/**
 * D1 (sub-sistemas): a aba Admin > Configurações > Sub-sistemas, com as seções do workspace na mesma tela: D3, os links
 * externos (abrem em nova aba a partir da tela inicial); D2, os ícones nas abas.
 */
const SECOES = [LinksExternos, IconesNasAbas];

export function AbaSubsistemas() {
  return <Subsistemas secoesWorkspace={SECOES} />;
}
